import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@shared/utils/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-regular transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        // Alias legacy que ya renderizaban solo las clases base.
        warning: null,
        success: null,
        default: 'border-transparent bg-primary text-white hover:bg-primary/80',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        'transparent-blue': 'bg-bg-info text-info',
        'transparent-orange': 'bg-bg-warning text-warning',
        'transparent-green': 'bg-bg-success text-success',
        'transparent-error': 'bg-bg-error text-error',
        'transparent-bright-error': 'bg-bg-bright-error text-bright-error',
        'badge-status-2': 'bg-badge-bg-status-2 text-badge-status-2',
        'badge-status-3': 'bg-badge-bg-status-3 text-badge-status-3',
        'badge-status-4': 'bg-badge-bg-status-4 text-badge-status-4',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
